export const SERVICE_URL = process.env.SERVICE_URL || 'http://localhost:16108/api';
